import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import Cookies from "js-cookie";
import { db } from "../../firebase.js";
import logo_default from "../../assets/logo_default.jpg";
import { Toast } from '../../components_root/ToastContext.jsx';
import Ledger_account_profile_popup from "./ledger_account_profile_popup.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Ledger_accounts_reports_profile({ accountguid }) {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState("");
    const { Toastshow } = Toast();
    const [IsLoading2, setIsLoading2] = useState(true);
    const navigate = useNavigate();
    const [slug, setSlug] = useState("");
    const [account_data, setAccount_data] = useState([]);
    const servicetablename = "companies";
    const [profileopen, setProfileopen] = useState(false);
    const fetch_accounts = () => {
        if (!accountguid) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        setIsLoading2(true);

        const ledgerQuery = query(
            collection(db, servicetablename, select_company_uid, "staff_accounts"),
            where("accountguid", "==", accountguid)
        );

        const unsubscribe = onSnapshot(
            ledgerQuery,
            async (snapshot) => {

                // ✅ if companies/staff_accounts has data
                if (!snapshot.empty) {

                    const ledgerDocs = snapshot.docs;

                    const mergedData = await Promise.all(
                        ledgerDocs.map(async (docSnap) => {
                            const ledgerData = { id: docSnap.id, ...docSnap.data() };


                            const accountDoc = await getDocs(
                                query(
                                    collection(db, "accounts"),
                                    where("guid", "==", accountguid)
                                )
                            );

                            let accountInfo = {};
                            if (!accountDoc.empty) {
                                accountInfo = {
                                    account_id: accountDoc.docs[0].id,
                                    ...accountDoc.docs[0].data(),
                                };
                            }

                            return {
                                ...ledgerData,
                                account_info: accountInfo
                            };
                        })
                    );

                    setAccount_data(mergedData);
                    setIsLoading2(false);
                    return;
                }

                // ✅ ELSE: fallback to accountingfinancedb/ledger_accounts
                const fallbackQuery = query(
                    collection(db, "accountingfinancedb", select_company_uid, "ledger_accounts"),
                    where("accountguid", "==", accountguid)
                );

                const fallbackSnap = await getDocs(fallbackQuery);

                const mergedData = await Promise.all(
                    fallbackSnap.docs.map(async (docSnap) => {
                        const ledgerData = { id: docSnap.id, ...docSnap.data() };

                        return {
                            ...ledgerData,
                            account_info: ledgerData
                        };
                    })
                );

                setAccount_data(mergedData);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching accounts:", error);
                setIsLoading2(false);
            }
        );

        return unsubscribe;
    };



    useEffect(() => {
        fetch_accounts();
    }, [accountguid]);

    useEffect(() => {
        fetch_accounts();
    }, [accountguid]);
    //
    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };

    const toggleProfile = () => {
        setProfileopen(prev => !prev);
    };

    return (
        <div >
            <div className="flex">
                <div className="cursor" onClick={toggleProfile}>
                    <img
                        style={{ height: "24px", width: "24px" }}
                        className="icon-img b-1 rounded-circle items-back-fill"
                        src={
                            account_data[0]?.account_info?.photoURL ||
                            logo_default
                        }
                        alt="photo"
                        onError={(e) => {
                            e.currentTarget.src = logo_default;
                        }}
                    />
                </div>
                <div className="text-h2 bold line-hight-25 fcap"> 
                        {account_data[0]?.account_info?.name || account_data[0]?.name || "N/A"} 
                </div>
            </div>
            <Ledger_account_profile_popup
                data={accountguid}
                isOpen={profileopen}
                onClose={() => setProfileopen(false)}
            />
        </div >
    );
}
